import React, { useState, useEffect } from 'react';
import useProductCompare from '../../hooks/productCompare/useProductCompare';

const ProductCompare = ({ url, num_products }) => {
  const [numProducts, setNumProducts] = useState(num_products || 1);
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const { response, setConfig } = useProductCompare();

  useEffect(() => {
    PubSub.subscribe('PRODUCT-COMPARE-ADDED', () => {
      getCompareProducts();
    });
  }, []);

  useEffect(() => {
    PubSub.publish('PRODUCT-COMPARE-UPDATED', products);

    if (numProducts === 0) {
      setOpen(false);
    }
  }, [products]);

  useEffect(() => {
    if (open) {
      getCompareProducts();
    }
  }, [open]);

  useEffect(() => {
    if (response.result) {
      const { success, data, updateProducts } = response.result;
      if (success && updateProducts) {
        setProducts(data);
        setError(false);
        setNumProducts(data.length);
        setConfig(null);
      } else if (success) {
        setConfig(null);
        getCompareProducts();
      } else {
        setConfig(null);
        setError(true);
      }
    }
  }, [response.result]);

  const clearAllCompareProducts = () => {
    removeCompareProduct();
  };

  const viewCompareProducts = () => {
    if (products.length > 1) {
      let newUrl = `${url}?products=${products
        .map(prod => {
          return prod.id;
        })
        .join(',')}`;
      location.href = newUrl;
    }
  };

  const viewProduct = product_url => {
    location.href = product_url;
  };

  const removeCompareProduct = product => {
    setConfig({
      method: 'DELETE',
      url: '/products_compare',
      params: { product_id: product },
    });
  };

  const getCompareProducts = () => {
    setConfig({ method: 'GET', url: '/products_compare', params: {} });
  };

  return (
    <div
      className={
        'product-compare--bar hidden-phone ' +
        (numProducts > 0 ? 'active' : '') +
        (open ? ' open' : '')
      }>
      <div className="container">
        <div className="fl compare-bar__info">
          <button
            className={'compare ' + (products.length < 2 ? 'inactive' : '')}
            onClick={viewCompareProducts}>
            Compare Products ({numProducts})
            <i className="icon-chevron-right" />
          </button>

          <button className="clear-all" onClick={clearAllCompareProducts}>
            Clear All
          </button>
          <button
            className="toggle-compare"
            onClick={() => {
              setOpen(!open);
            }}>
            {open ? 'Close' : 'Open'}
            {open ? (
              <i className="icon-chevron-down" />
            ) : (
              <i className="icon-chevron-up" />
            )}
          </button>
        </div>
        <div className="row compare-products">
          {products.map(
            ({ id, image, url, catalogue, description, stock_code }, index) => (
              <div className="span4" key={index}>
                <div className="product--preview">
                  <i
                    className="icon-remove"
                    aria-label="remove icon"
                    onClick={() => {
                      removeCompareProduct(id);
                    }}
                  />
                  <div
                    className="product-image"
                    onClick={() => {
                      viewProduct(url);
                    }}>
                    <img src={image} aria-label="product image" />
                  </div>
                  <div
                    className="product-detail"
                    onClick={() => {
                      viewProduct(url);
                    }}>
                    <h4>{description}</h4>
                    Part Code: <strong>{catalogue}</strong>
                    <br />
                    Stock Code: <strong>{stock_code}</strong>
                  </div>
                  <div className="clearfix" />
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCompare;
